import StudyListTable from './StudyListTable';
import StudyListTableRow from './StudyListTableRow';

export default StudyListTable;

export { StudyListTable, StudyListTableRow };
